module.exports = __webpack_public_path__ + "static/media/logo.b4e076c4.png";